module.exports = __webpack_public_path__ + "static/media/42k.f31c86ee.webp";